import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Feedback my sample d3.js screencast",
  "description": "",
  "published": "2014-05-15T00:00:00.000Z",
  "redirect_from": ["/blog/feedback-my-sample-d3-js-screencast/swizec/6575"],
  "categories": "d3.js, Graphics, Screencast, Uncategorized, YouTube",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Packt convinced me to bite the `}<a parentName="p" {...{
        "href": "http://protovis.org/",
        "title": "D3.js"
      }}>{`d3.js`}</a>{` bullet once more. Following the `}<a parentName="p" {...{
        "href": "http://www.packtpub.com/data-visualization-with-d3js/book"
      }}>{`Data Visualization with d3.js book`}</a>{`, I am now working on a video course aimed at advanced users.`}</p>
    <p>{`It's going to be chock full of going into details about layouts, data manipulation, geography and other fun stuff. Definitely none of that `}<em parentName="p">{`"This is how you place a `}<a parentName="em" {...{
          "href": "http://www.w3.org/Graphics/SVG/",
          "title": "Scalable Vector Graphics"
        }}>{`SVG`}</a>{` element. This is how you bind data to elements. This is how you ..."`}</em></p>
    <p>{`Snore.`}</p>
    <p>{`Pretty much all d3.js screencasts and courses I was able to find focus on beginners. There will be none of that here, I'm going to assume you've made at least three things with d3.js before tackling my videos.`}</p>
    <p>{`So roughly the same experience I've got.`}</p>
    <p>{`That said, I made a sample screencast last week to test the process out. The topic will fit towards the end of the course, where I try to explain the design part of visualisations.`}</p>
    <p>{`Now, this is my first ever recording of a screencast. I have no idea what I'm doing. `}<em parentName="p">{`Do not`}</em>{` be gentle! If there's something wrong, I have to know. `}<em parentName="p">{`Now!`}</em></p>
    <p>{`If you tell me I suck six months from now when the course is published, it will be too late. Tell me my accent sucks, now. Tell me I speak at a funny pace, now. Tell me you can't understand what I'm saying, now.`}</p>
    <p>{`And tell me I need a better mic. Then suggest which one I should get because this was recorded on the default apple headphones microphone.`}</p>
    <p>{`Also, I'm going to need volunteers to beta read my scripts and beta watch the videos. The schedule says scripts will be coming out at a decent cadence of one every two weeks over the next two months. Then I'll be making the screencasts themselves over summer and the course should be out in September.`}</p>
    <p>{`I'm making this for you guys. Help me make it awesomer.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=be236c6a-a75f-4d2b-b773-b8c633e2d197",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      